"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7266],{

/***/ 79592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16423);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: initial;\n  border: none;\n  text-decoration: none;\n  &:focus {\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Link = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_1___default()))(_templateObject(), (param)=>{
    let { theme , $origin , $textSecondary , $error , $nowrap , $color , href  } = param;
    return "\n    color: ".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([
        [
            (props)=>props.$error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.$origin,
            ()=>theme.palette.text.primary
        ],
        [
            (props)=>props.$textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            ()=>true,
            ()=>theme.palette.primary.main
        ]
    ])({
        $origin,
        $textSecondary,
        $error,
        $color
    }), ";\n    white-space: ").concat($nowrap ? "nowrap" : "normal", ";\n    cursor: ").concat(href !== "" ? "pointer" : "default", ";\n\n    &:hover {\n      color: ").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([
        [
            (props)=>props.$error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.$origin,
            ()=>theme.palette.text.primary
        ],
        [
            (props)=>props.$textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            ()=>true,
            ()=>theme.palette.primary.main
        ]
    ])({
        $origin,
        $textSecondary,
        $error,
        $color
    }), ";\n    }\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 18450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D2": function() { return /* binding */ HideInDesktopGrid; },
/* harmony export */   "W": function() { return /* binding */ HideInMobileGrid; },
/* harmony export */   "aI": function() { return /* binding */ HideInDesktopBox; },
/* harmony export */   "dz": function() { return /* binding */ HideInMobileBox; }
/* harmony export */ });
/* unused harmony exports withHideInMobile, withHideInDesktop */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79072);



const withHideInMobile = (WrappedComponent)=>{
    return (param)=>{
        let { display ="block" , sx ={} , component , ...props } = param;
        const finalDisplay = props.display === "flex" ? "flex" : component === "span" ? "inline-block" : display;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            sx: {
                display: {
                    xs: "none",
                    lg: finalDisplay
                },
                ...sx
            },
            ...props
        });
    };
};
const withHideInDesktop = (WrappedComponent)=>{
    return (param)=>{
        let { display ="block" , sx ={} , component , ...props } = param;
        const finalDisplay = props.display === "flex" ? "flex" : component === "span" ? "inline-block" : display;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            sx: {
                display: {
                    xs: finalDisplay,
                    lg: "none"
                },
                ...sx
            },
            ...props
        });
    };
};
const HideInMobileBox = withHideInMobile(_mui_material_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
const HideInDesktopBox = withHideInDesktop(_mui_material_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
const HideInMobileGrid = withHideInMobile(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);
const HideInDesktopGrid = withHideInDesktop(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);


/***/ }),

/***/ 37524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N1": function() { return /* binding */ ScrollableBox; },
/* harmony export */   "OW": function() { return /* binding */ FullscreenModal; },
/* harmony export */   "nv": function() { return /* binding */ InfoModal; },
/* harmony export */   "rK": function() { return /* binding */ FunctionModal; },
/* harmony export */   "tn": function() { return /* binding */ UserDataModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39477);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25425);
/* harmony import */ var _mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9942);
/* harmony import */ var _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58735);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  overflow-y: auto;\n  scrollbar-width: none;\n  border: none;\n  outline: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  @media screen and (min-width: 992px) {\n    width: 540px;\n    height: initial;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}







const functionModalBackdropProps = {
    timeout: 500
};
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , $autoHeight  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n\n    @media screen and (min-width: 992px) {\n      margin-top: 20px;\n      width: 540px;\n      height: ").concat($autoHeight ? "auto" : "737px", ";\n      border-radius: 10px;\n    }\n  ");
});
const ScrollableBox = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1());
// fullscreen in mobile devices
const FunctionModal = (param)=>{
    let { open , onClose , children , autoHeight , ModalWrapper , ...rest } = param;
    const UsedWrapper = ModalWrapper || Wrapper;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            direction: "up",
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UsedWrapper, {
                    onClick: (e)=>e.stopPropagation(),
                    $autoHeight: autoHeight,
                    children: children
                })
            })
        })
    });
};
const Fullscreen = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2(), (param)=>{
    let { theme , $autoHeight  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 100%;\n    height: ").concat($autoHeight ? "auto" : "100%", ";\n    min-height: ").concat($autoHeight ? "100vh" : "auto", ";\n    margin: 0 auto;\n  ");
});
// fullscreen in any devices
const FullscreenModal = (param)=>{
    let { open , onClose , children , autoHeight , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Slide__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            direction: "up",
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Fullscreen, {
                    onClick: (e)=>e.stopPropagation(),
                    $autoHeight: autoHeight,
                    children: children
                })
            })
        })
    });
};
const InfoWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: calc(100% - 60px);\n    max-width: 540px;\n    height: initial;\n    margin: 0 auto;\n    border-radius: 10px;\n  ");
});
const UserDataWrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject4(), (param)=>{
    let { theme  } = param;
    return "\n    overflow: hidden;\n    position: relative;\n    background-color: ".concat(theme.palette.background.paper, ";\n    width: 354px;\n    height: initial;\n    margin: 0 auto;\n    font-size: 16px;\n    border-radius: 12px;\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.1);\n  ");
});
// regular modal even in mobile devices
const InfoModal = (param)=>{
    let { open , onClose , children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    pt: "150px",
                    pb: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(InfoWrapper, {
                        onClick: (e)=>e.stopPropagation(),
                        children: children
                    })
                })
            })
        })
    });
};
// user data modal
const UserDataModal = (param)=>{
    let { open , onClose , children , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: open,
        onClose: onClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material_Backdrop__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        BackdropProps: functionModalBackdropProps,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Fade__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            in: open,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableBox, {
                onClick: ()=>onClose && onClose(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    pt: "150px",
                    pb: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UserDataWrapper, {
                        onClick: (e)=>e.stopPropagation(),
                        children: children
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 47624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ FacebookIconSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const FacebookIconSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            className: "ic_share_facebook",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "20",
                    cy: "20",
                    r: "20",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 9.982 7.314 18.257 16.875 19.757V25.781h-5.078V20h5.078v-4.406c0-5.013 2.986-7.781 7.554-7.781 2.189 0 4.477.39 4.477.39v4.922h-2.522c-2.484 0-3.259 1.542-3.259 3.123V20h5.547l-.887 5.781h-4.66v13.976C32.686 38.257 40 29.983 40 20Z",
                    className: "Vector"
                })
            ]
        })
    });
};


/***/ }),

/***/ 52915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ LineCircleSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const LineCircleSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "Logo_Line",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                className: "LINE_LOGO",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    className: "Group",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#4CC764",
                            d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
                            className: "Vector"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            className: "Group",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fill: "#fff",
                                    d: "M20.003 11.301c0-3.585-3.595-6.501-8.011-6.501-4.417 0-8.011 2.917-8.011 6.501 0 3.214 2.85 5.905 6.7 6.414.26.056.616.172.706.395.08.203.052.52.026.725l-.114.685c-.035.203-.162.792.694.432.854-.36 4.613-2.716 6.293-4.65 1.162-1.274 1.718-2.566 1.718-4l-.002-.001Z",
                                    className: "Vector"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    className: "Group",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "#4CC764",
                                        d: "M17.338 13.371a.153.153 0 0 0 .153-.153v-.568a.154.154 0 0 0-.153-.153h-1.53v-.59h1.53a.153.153 0 0 0 .153-.154v-.567a.154.154 0 0 0-.153-.153h-1.53v-.59h1.53a.153.153 0 0 0 .153-.154v-.567a.154.154 0 0 0-.153-.153h-2.251a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h2.25Zm-8.325 0a.153.153 0 0 0 .153-.153v-.568a.154.154 0 0 0-.153-.153h-1.53V9.722a.154.154 0 0 0-.152-.153h-.569a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h2.25Zm1.354-3.802H9.8a.153.153 0 0 0-.153.153v3.495c0 .085.069.153.153.153h.568a.153.153 0 0 0 .153-.153V9.722a.153.153 0 0 0-.153-.153Zm3.868 0h-.569a.153.153 0 0 0-.152.153v2.076l-1.6-2.16-.012-.015H11.9a.03.03 0 0 0-.009-.01l-.003-.003-.008-.007c-.002 0-.003-.002-.005-.003l-.008-.005c-.002 0-.003-.002-.005-.003l-.008-.005-.004-.002-.01-.004-.005-.001-.008-.003c-.002 0-.004 0-.006-.002l-.009-.002h-.007l-.008-.001h-.578a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h.569a.153.153 0 0 0 .152-.153v-2.076l1.602 2.163a.147.147 0 0 0 .04.038l.001.002.01.006.004.002.008.004.007.003.005.001a.057.057 0 0 0 .01.003h.002a.144.144 0 0 0 .04.006h.565a.153.153 0 0 0 .153-.153V9.724a.153.153 0 0 0-.153-.153v-.002Z",
                                        className: "Vector"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 54806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16423);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46338);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const SVG = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].svg */ .Z.svg(_templateObject(), (param)=>{
    let { theme , primary , error , white , textSecondary , $ptr , $color  } = param;
    return "\n    fill: ".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)([
        [
            (props)=>props.error,
            ()=>theme.palette.error.main
        ],
        [
            (props)=>props.primary,
            ()=>theme.palette.primary.main
        ],
        [
            (props)=>props.white,
            ()=>theme.palette.primary.contrastText
        ],
        [
            (props)=>props.textSecondary,
            ()=>theme.palette.text.secondary
        ],
        [
            (props)=>!!props.$color,
            ()=>(0,lodash_es__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(theme.palette, $color)
        ],
        [
            lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            ()=>theme.palette.text.primary
        ]
    ])({
        primary,
        error,
        white,
        textSecondary,
        $color
    }), ";\n    ").concat($ptr ? "cursor: pointer;" : "", "\n  ");
});
/* harmony default export */ __webpack_exports__["Z"] = (SVG);


/***/ }),

/***/ 98780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var _mui_icons_material_ExpandLess__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60181);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const ScrollButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    position: fixed;\n    bottom: 100px;\n    right: 20px;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%);\n    background-color: ".concat(theme.palette.grey.third, ";\n    border: 1px solid ").concat(theme.palette.grey.secondary, ";\n    cursor: pointer;\n    color: ").concat(theme.palette.text.primary, ";\n    z-index: 98;\n\n    &:active {\n      background-color: ").concat(theme.palette.primary.bgPlus1, ";\n      border: 1px solid #ffffff;\n    }\n\n    > .muiIcon {\n      position: absolute;\n      top: 50%; \n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n  ");
});
const ScrollToTopButton = (param)=>{
    let { showButton , scrollableRef , isAutoScroll  } = param;
    const onScrollToTopClick = ()=>{
        setTimeout(()=>{
            var _scrollableRef_current;
            return scrollableRef.current && ((_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                top: 0,
                behavior: "smooth"
            }));
        }, 0);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isAutoScroll) {
            setTimeout(()=>{
                var _scrollableRef_current;
                return scrollableRef.current && ((_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                    top: 0,
                    behavior: "smooth"
                }));
            }, 0);
        }
    }, [
        isAutoScroll
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButton, {
        style: {
            display: showButton ? "inline" : "none"
        },
        onClick: onScrollToTopClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_ExpandLess__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            fontSize: "large",
            className: "muiIcon"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollToTopButton);


/***/ }),

/***/ 53258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useStateRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useStateRef = ()=>{
    const [node, setNode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((node)=>{
        setNode(node);
    }, []);
    return [
        node,
        ref
    ];
};


/***/ }),

/***/ 13946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xh": function() { return /* binding */ useAlbumModal; },
/* harmony export */   "_S": function() { return /* binding */ usePreselectVenderManagement; },
/* harmony export */   "cB": function() { return /* binding */ useGetYearForFooter; },
/* harmony export */   "h3": function() { return /* binding */ useImageLoaded; },
/* harmony export */   "hq": function() { return /* binding */ useConfirmModalHandler; },
/* harmony export */   "o4": function() { return /* binding */ useDateTypeText; },
/* harmony export */   "zi": function() { return /* binding */ useShowScrollToTopButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89289);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79697);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39705);
/* harmony import */ var store_cache_cacheSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24363);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62097);








const useDateTypeText = (services, serviceIds)=>{
    const [dateTypeText, setDateTypeText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("施作");
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!(0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(services)) {
            const selectedNonStandardService = services.some((service)=>(serviceIds || []).includes(service._id) && !service.isStandard);
            setDateTypeText(selectedNonStandardService ? "估價" : "施作");
        }
    }, [
        services,
        serviceIds
    ]);
    return dateTypeText;
};
const confirmModelInit = {
    open: false,
    onPositiveClick: ()=>{},
    onNegativeClick: ()=>{},
    positiveButtonText: null,
    negativeButtonText: null,
    title: "",
    message: ""
};
const useConfirmModalHandler = ()=>{
    const [confirmModelConfig, setConfirmModelConfig] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(confirmModelInit);
    const close = ()=>{
        setConfirmModelConfig({
            ...confirmModelInit
        });
    };
    const open = (config)=>{
        setConfirmModelConfig({
            ...confirmModelInit,
            onNegativeClick: close,
            open: true,
            ...config
        });
    };
    return [
        confirmModelConfig,
        open,
        close
    ];
};
const useAlbumModal = (pathname, router, options)=>{
    const { webview , nativeHeaderHandler  } = options;
    const [albumModal, setAlbumModal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        open: false
    });
    const closeAlbumModal = ()=>setAlbumModal({
            open: false
        });
    const onAlbumClick = (e, album)=>{
        var _album_urlId, _album_urlId_toLowerCase, _window_location_href_split;
        e.stopPropagation();
        e.preventDefault();
        if (!album) {
            throw new Error("useAlbumModal: album is undefined");
        }
        const albumUrlId = (_album_urlId_toLowerCase = (_album_urlId = album.urlId).toLowerCase) === null || _album_urlId_toLowerCase === void 0 ? void 0 : _album_urlId_toLowerCase.call(_album_urlId);
        const state = {
            ...window.history.state,
            url: "/album/".concat(albumUrlId),
            as: "/album/".concat(albumUrlId),
            idx: window.history.state.idx + 1
        };
        const photo = (album === null || album === void 0 ? void 0 : album.representativePhoto) || (album === null || album === void 0 ? void 0 : album.frontCover);
        const photoUrlId = photo === null || photo === void 0 ? void 0 : photo.urlId;
        const qs = ((_window_location_href_split = window.location.href.split("?")) === null || _window_location_href_split === void 0 ? void 0 : _window_location_href_split[1]) || "";
        const newQs = qs.split("&").filter((string)=>string && !/^(utm_|page=|tag=)/.test(string)).concat([
            "photoId=".concat(photoUrlId)
        ]).join("&");
        window.history.pushState(state, "", "/album/".concat(albumUrlId, "?").concat(newQs));
        router.query.albumUrlId = albumUrlId;
        router.query.photoId = photoUrlId;
        setAlbumModal({
            open: true,
            fallbackData: {
                photoUrlId: photoUrlId
            }
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handlePopState = ()=>{
            if (location.pathname === pathname && albumModal.open) {
                setAlbumModal({
                    open: false
                });
                if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp" && nativeHeaderHandler) {
                    nativeHeaderHandler();
                }
            }
        };
        window.addEventListener("popstate", handlePopState);
        return ()=>{
            window.removeEventListener("popstate", handlePopState);
        };
    }, [
        albumModal
    ]);
    const onAlbumContentClose = ()=>{
        router.back();
        closeAlbumModal();
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp" && nativeHeaderHandler) {
            nativeHeaderHandler();
        }
    };
    return {
        albumModal,
        closeAlbumModal,
        onAlbumClick,
        onAlbumContentClose
    };
};
const usePreselectVenderManagement = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const [nextRoute, setNextRoute] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    // 當跳轉到非下訂流程時，移除preselectVender
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const onRouteChangeStart = (url, param)=>{
            let { shallow  } = param;
            if (shallow) {
                return;
            }
            const qs = url.split("?")[1] || "";
            const hasPreselectVender = qs.split("&").some((str)=>/^preselect_vender=/.test(str));
            if (!hasPreselectVender) {
                return;
            }
            if (!/^(\/service\/|\/login)/.test(url)) {
                const newQs = qs.split("&").filter((str)=>!/^preselect_vender=/.test(str)).join("&");
                dispatch((0,store_cache_cacheSlice__WEBPACK_IMPORTED_MODULE_3__/* .clearPreselectVender */ .mT)());
                setNextRoute(url.split("?")[0] + (newQs ? "?" + newQs : ""));
                router.events.emit("routeChangeError");
                throw "route change aborted";
            }
        };
        if (nextRoute) {
            router.push(nextRoute);
        }
        router.events.on("routeChangeStart", onRouteChangeStart);
        return ()=>{
            router.events.off("routeChangeStart", onRouteChangeStart);
        };
    }, [
        nextRoute
    ]);
};
const useGetYearForFooter = ()=>{
    const [currentYear, setCurrentYear] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setCurrentYear((0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(), "yyyy"));
    }, []);
    return currentYear;
};
const useShowScrollToTopButton = ()=>{
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    const [showButton, setShowButton] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(theme.breakpoints.down("md"));
    const showScrollButton = (e)=>{
        if (isMobile) {
            e.currentTarget.scrollTop > 768 ? setShowButton(true) : setShowButton(false);
        } else {
            e.currentTarget.scrollTop > 800 ? setShowButton(true) : setShowButton(false);
        }
    };
    return {
        showButton,
        showScrollButton
    };
};
const useImageLoaded = ()=>{
    const [isImageLoaded, setIsImageLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const onLoadComplete = ()=>{
        setIsImageLoaded(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (ref.current && ref.current.complete) onLoadComplete();
    }, []);
    return [
        ref,
        isImageLoaded,
        onLoadComplete
    ];
};


/***/ })

}]);